import Cookies from "universal-cookie";
import { PoweroffOutlined } from "@ant-design/icons";
import { withRouter } from "../../hoc/withRouter";

const ButtonLogout = (props) => {
  const onPressed = () => {
    try {
      const cookies = new Cookies();
      cookies.remove("_bbn_tn");
      cookies.remove("_bbn_un");
      cookies.remove("_bbn_ls");
      cookies.remove("_bbn_df");
      cookies.remove("_bbn_m");

      // Trigger logout event to other tabs
      const bc = new BroadcastChannel("logout_channel");
      bc.postMessage("logout");
      bc.close();
    } catch (error) {
      console.error("Failed to remove cookies:", error);
    }

    props.history.push("/login");
  };

  return <PoweroffOutlined onClick={onPressed} style={{ padding: 0, marginLeft: 5, paddingRight: 10 }} />;
};

export default withRouter(ButtonLogout);
